import { useState } from 'react'
import Button from '@mui/material/Button'
import { AutonumberDetails } from 'field-governance/components'
import { RequiredTextField } from '../components/required-text-field'
import { t } from '@lingui/core/macro'

export const Autonumber = ({ segment, updateSegment }) => {
  const [updatedSegment, setUpdatedSegment] = useState({ ...segment })

  const onUpdate = () => {
    updateSegment(updatedSegment)
  }

  const isButtonDisabled =
    !updatedSegment.name ||
    !updatedSegment.autonumber.start_value ||
    !updatedSegment.autonumber.min_width

  return (
    <div style={{ padding: 12, paddingTop: 24 }}>
      <div>
        <RequiredTextField value={updatedSegment} onChange={setUpdatedSegment} label={t`Name`} />
      </div>
      <AutonumberDetails
        startValue={updatedSegment.autonumber.start_value}
        minWidth={updatedSegment.autonumber.min_width}
        updater={setUpdatedSegment}
      />
      <div style={{ marginTop: 24 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={onUpdate}
          style={{ width: '100%' }}
          disabled={isButtonDisabled}
        >
          {t`Done`}
        </Button>
      </div>
    </div>
  )
}
